/**Dependencies */
import React from "react";

/**Components */
import { Button } from "react-bootstrap";

/**Images */
import { FaPhoneAlt } from "react-icons/fa";
import bannerExperiencia from "../images/banners/banner-experiencia.jpg";
import bannerExperienciaMobile from "../images/banners/banner-experiencia-mobile.png";

/**
 * Componente que muestra un banner con la experiencia de International
 * para celulares y escritorio
 */
export const BannerExperience = () => {
  return (
    <>
      <div
        className="d-none d-lg-block"
        style={{
          position: "relative",
          width: "100%",
          height: "360px",
          overflow: "hidden",
        }}
      >
        <img
          src={bannerExperiencia}
          alt="Banner"
          style={{ width: "100%" }}
        />
        <div
          style={{
            position: "absolute",
            top: "62%",
            right: "32%",
            transform: "translateY(-50%)",
          }}
        >
          <a
            href="tel:+7772035097"
            style={{ fontSize: "17px", color: "white" }}
          >
            <Button
              className="btn-blue"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 20px",
                fontSize: "1.7rem",
              }}
            >
              {" "}
              <FaPhoneAlt style={{ marginRight: "10px" }} /> 777 203 5097{" "}
            </Button>
          </a>
        </div>
      </div>
      <div
        className="d-block d-lg-none"
        style={{
          position: "relative",
          width: "100%",
          height: "300px",
          overflow: "hidden",
        }}
      >
        <img
          src={bannerExperienciaMobile}
          alt="Banner"
          style={{ width: "100%", height: "100%", objectFit: "fill" }}
        />
        <div
          style={{
            position: "absolute",
            top: "80%",
            right: "60%",
            transform: "translateY(-50%)",
          }}
        >
          <a
            href="tel:+7772035097"
            style={{ fontSize: "17px", color: "white" }}
          >
            <Button
              className="btn-blue"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 20px",
                fontSize: "1.7rem",
              }}
            >
              {" "}
              <FaPhoneAlt style={{ marginRight: "10px" }} /> 777 203 5097{" "}
            </Button>
          </a>
        </div>
      </div>
    </>
  );
};
